<script setup lang="ts">
import { ButtonVariants, DSButtonIndicator } from '@ds'

type Props = {
  size?: ButtonVariants['size']
  variant?: ButtonVariants['variant']
  indicator?: boolean
  clearable?: boolean
  readonly?: boolean
}

const { size = 'icon-sm', variant = 'secondary' } = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click:clear'): void
}>()
</script>

<template>
  <DSButtonIndicator
    type="button"
    :variant
    :size
    :indicator
    :clearable
    :readonly
    class="border-border/50"
    :class="{
      '[&>svg]:size-4!': size === 'md',
      '[&>svg]:size-3!': ['icon-sm', 'sm'].includes(size ?? ''),
    }"
    @click:clear="emit('click:clear')"
  >
    <slot />
  </DSButtonIndicator>
</template>
